// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

import { useNavigate } from "react-router-dom";
import {
  Box,
  Dialog,
  DialogContent,
  FormControl,
  IconButton,
  MenuItem,
  Select,
  Tab,
  Tabs,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useGetAllQuotesMutation } from "services/quote";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import MDBadge from "components/MDBadge";
import MDInput from "components/MDInput";
import MDAvatar from "components/MDAvatar";
import MDButton from "components/MDButton";
import { useRevertQuoteMutation } from "services/quote";
import ShowToast from "components/MDToast";
import { isNumber } from "utils/validations";
import { useGetAllProductsMutation } from "services/product";
import Pagination from "components/Pagination";
import Loader from "helpers/constants/Loader";
import { getFromStorage } from "helpers";
import { STORAGE_KEYS } from "helpers";
import useTranslation from "hooks/Translation";

const ManageQuotes = () => {
  const navigate = useNavigate();
  const t = useTranslation();
  const getLang = getFromStorage(STORAGE_KEYS.language);
  const currency = getFromStorage(STORAGE_KEYS.currency);
  const [getQuoteListing] = useGetAllQuotesMutation();
  const [getProducts] = useGetAllProductsMutation();
  const [revertQuote] = useRevertQuoteMutation();
  const [productData, setProductData] = useState([]);
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(0);
  const [selectedId, setSelectedId] = useState("");
  const handleSetTabValue = (event, newValue) => setTabValue(newValue);
  const [quoteData, setQuoteData] = useState([]);
  const [selectedCondition, setSelectedCondition] = useState("");
  const [selectedPayment, setSelectedPayment] = useState("");
  const [error, setError] = useState(false);
  const [price, setPrice] = useState("");
  const [time, setTime] = useState("");
  const [selectedProduct, setSelectedProduct] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalRecords, setTotalRecords] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);

  const handleDeliveryChange = (event) => {
    setSelectedCondition(event.target.value);
  };

  const handlePaymentChange = (event) => {
    setSelectedPayment(event.target.value);
  };

  const handleChangeProduct = (event) => {
    setSelectedProduct(event.target.value);
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
    // formik.setFieldError("message", "");
  };

  const getData = async (page) => {
    setLoading(true);
    try {
      let body = {
        order_status:
          tabValue === 0 ? 1 : tabValue === 1 ? 4 : tabValue === 2 ? 3 : 2,
        start: page,
        length: 10,
        search: debouncedSearchTerm,
      };

      const res = await getQuoteListing({ body: body }).unwrap();
      if (res?.status === 200) {
        setLoading(false);
        setQuoteData(res?.data?.response_object || []);
        setTotalRecords(res?.data?.total_records);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const handleRequestStatus = async (id) => {
    // Create the body object based on the status

    if (!selectedPayment) {
      return;
    }

    if (!selectedCondition) {
      return;
    }

    if (!time?.length) {
      return;
    }

    if (!price?.length) {
      return;
    }

    const body = {
      price_per_unit: price,
      offer_valid_time: time,
      delivery_condItions: Number(selectedCondition),
      payment_method: Number(selectedPayment),
      product: selectedProduct,
    };

    try {
      const response = await revertQuote({
        body,
        id: id,
      }).unwrap();
      if (response?.status === 200) {
        ShowToast("Quote sent successfully", "success");
        setOpen(false);
        getData();
      } else {
        ShowToast("Please try again", "error");
      }
    } catch {
      ShowToast("Something went wrong", "error");
    }
  };

  const Job = ({ title, description }) => (
    <MDBox lineHeight={1} textAlign="left" sx={{ minWidth: "120px" }}>
      <MDTypography display="block" variant="caption" fontWeight="medium">
        {title}
      </MDTypography>
      <MDTypography variant="caption">{description}</MDTypography>
    </MDBox>
  );
  const Name = ({ title, description }) => (
    <MDBox lineHeight={1} textAlign="left" sx={{ minWidth: "120px" }}>
      <MDTypography display="block" variant="caption" fontWeight="medium">
        {title}
      </MDTypography>
      <MDTypography variant="caption">{description}</MDTypography>
    </MDBox>
  );

  const Quantity = ({ title, description }) => (
    <MDBox lineHeight={1} textAlign="left" sx={{ minWidth: "180px" }}>
      <MDTypography display="block" variant="caption" fontWeight="medium">
        {title}
      </MDTypography>
      <MDTypography variant="caption">{description}</MDTypography>
    </MDBox>
  );

  const Req = ({ title, description }) => (
    <MDBox lineHeight={1} textAlign="left" sx={{ maxWidth: "400px" }}>
      <MDTypography display="block" variant="caption" fontWeight="medium">
        {title}
      </MDTypography>
      <MDTypography variant="caption">{description}</MDTypography>
    </MDBox>
  );

  const columns = [
    {
      Header: t.main.customerName,
      accessor: "name",
      align: "left",
    },
    { Header: t.main.email, accessor: "email", align: "left" },
    { Header: t.main.category, accessor: "cat", align: "left" },
    { Header: t.main.subCategory, accessor: "sub", align: "left" },

    { Header: t.main.productQuantity, accessor: "quantity", align: "left" },
    { Header: t.main.price, accessor: "price", align: "left" },
    { Header: t.main.specificReq, accessor: "stock", align: "left" },

    ...(tabValue === 0
      ? []
      : [{ Header: t.main.chat, accessor: "chat", align: "center" }]),
    { Header: t.main.quoteStatus, accessor: "status", align: "center" },

    ...(tabValue === 0
      ? [{ Header: t.main.actions, accessor: "action", align: "center" }]
      : []),
  ];

  const rows = quoteData?.map((item) => ({
    name: <Name title={item?.consumer_name || "-"} />,
    email: <Job title={item?.consumer_email || "-"} />,
    cat: <Job title={item?.category || "-"} />,
    sub: <Job title={item?.sub_category || "-"} />,
    // price: <Job title="Fruits" />,
    quantity: <Quantity title={item?.quantity || "-"} />,
    price: (
      <Quantity
        title={`${currency === "USD" ? "USD" : "AED"} ${item?.price || "0"}`}
      />
    ),
    status: (
      <MDBox ml={-1} sx={{ minWidth: "140px" }}>
        <MDBadge
          badgeContent={
            tabValue === 0 ? "Quote not submitted" : "Quote submitted"
          }
          color="dark"
          variant="gradient"
          size="md"
        />
      </MDBox>
    ),
    stock: <Req title={item?.specific_requirement || "-"} />,
    chat: (
      <MDBox>
        {tabValue === 0 ? null : (
          <IconButton
            size="small"
            sx={{ color: "#2B604C" }}
            onClick={() =>
              navigate("/quote-chat", { state: { sessionId: item?.session } })
            }
          >
            <ChatBubbleIcon />
          </IconButton>
        )}
      </MDBox>
    ),
    action: (
      <MDBox>
        {tabValue === 0 ? (
          <MDBox
            sx={{ cursor: "pointer" }}
            onClick={() => {
              setSelectedId(item?.id);
              setOpen(true);
              setSelectedProduct(item?.product_id);
            }}
          >
            <MDBadge
              badgeContent="Send Quotation"
              color="success"
              variant="gradient"
              size="md"
            />
          </MDBox>
        ) : null}
      </MDBox>
    ),
  }));

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await getProducts({ start: 1, length: 10 }).unwrap();
        if (response?.status === 200) {
          setProductData(response?.data?.response_object);
          setTotalRecords(response?.data?.total_records);
        } else {
          setProductData([]);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchProducts();
  }, []);

  const totalPages = Math.ceil(totalRecords / limit);

  useEffect(() => {
    getData();
  }, [tabValue, page, debouncedSearchTerm]);

  return (
    <DashboardLayout>
      <Loader loading={loading} />
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                // variant="gradient"
                bgColor="theme-1"
                borderRadius="lg"
                coloredShadow="info"
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <MDTypography variant="h6" color="white">
                  {t.main.quotesTable}
                </MDTypography>
              </MDBox>

              <MDBox pt={2} pl={2} pr={2}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6} lg={6}>
                    <Tabs
                      value={tabValue}
                      onChange={handleSetTabValue}
                      orientation={tabsOrientation}
                      className="custom_tabs_links"
                    >
                      <Tab
                        sx={{ fontWeight: "500" }}
                        label={t.main.pending}
                        {...a11yProps(0)}
                      />
                      <Tab
                        sx={{ fontWeight: "500" }}
                        label={t.main.inProgress}
                        {...a11yProps(1)}
                      />
                      <Tab
                        sx={{ fontWeight: "500" }}
                        label={t.main.accepted}
                        {...a11yProps(2)}
                      />
                      <Tab
                        sx={{ fontWeight: "500" }}
                        label={t.main.rejected}
                        {...a11yProps(3)}
                      />
                    </Tabs>
                  </Grid>
                </Grid>
              </MDBox>

              <MDBox pt={3} pl={2} pr={2}>
                {quoteData?.length ? (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                ) : (
                  <MDBox
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    py={5}
                  >
                    <MDTypography variant="h6" color="text">
                      {t.error.noData}
                    </MDTypography>
                  </MDBox>
                )}
              </MDBox>
              {quoteData.length > 0 ? (
                <MDBox p={2}>
                  <Pagination
                    setPage={setPage}
                    module={quoteData}
                    page={page}
                    onPageChange={setPage}
                    totalPages={totalPages}
                    limit={limit}
                    setLimit={setLimit}
                  />
                </MDBox>
              ) : (
                ""
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Dialog open={open} onClose={handleClose} className="revert_dialog">
        <DialogContent>
          <MDTypography variant="h5" fontWeight="medium" color="black" mb={1}>
            {t.main.sendQuotation}
          </MDTypography>
          <form>
            <FormControl fullWidth>
              <MDBox mb={2}>
                <MDInput
                  type="text"
                  placeholder={t.main.pricePerUnit}
                  variant="outlined"
                  fullWidth
                  inputProps={{ maxLength: 10 }}
                  onChange={(val) => {
                    const value = val.target.value;
                    if (value === " " || value === ".") return;

                    // Regex to allow only numbers with up to two decimal places
                    if (/^\d*\.?\d{0,2}$/.test(value)) {
                      setPrice(value);
                    }
                  }}
                  value={price}
                  error={error && !price?.length}
                />
              </MDBox>
              <MDBox mb={2}>
                <MDInput
                  type="text"
                  placeholder={t.main.timeFrame}
                  variant="outlined"
                  fullWidth
                  onChange={(val) => {
                    if (isNumber(val.target.value)) {
                      setTime(val.target.value);
                    }
                  }}
                  value={time}
                  error={error && !time?.length}
                />
              </MDBox>

              <MDBox mb={2}>
                <FormControl fullWidth>
                  <Select
                    className="select_div"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    displayEmpty
                    value={selectedCondition}
                    onChange={handleDeliveryChange}
                    error={error && !selectedCondition}
                    sx={{
                      border:
                        error && !selectedCondition
                          ? "1px solid red"
                          : "1px solid grey", // Add a custom border color
                      borderRadius: "6px", // Optional: Add border radius for styling
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "grey", // Adjust border color for the outlined variant
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "grey", // Border color on hover
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "grey", // Border color when focused
                      },
                    }}
                  >
                    <MenuItem value="" disabled>
                      {t.main.deliveryConditions}
                    </MenuItem>

                    <MenuItem value={"1"}>{t.main.shippingCharge}</MenuItem>
                    <MenuItem value={"2"}>{t.main.freeDelivery}</MenuItem>
                  </Select>
                </FormControl>
              </MDBox>
              <MDBox mb={2}>
                <FormControl fullWidth>
                  <Select
                    className="select_div"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    displayEmpty
                    value={selectedPayment}
                    onChange={handlePaymentChange}
                    error={error && !selectedPayment}
                    sx={{
                      border:
                        error && !selectedPayment
                          ? "1px solid red"
                          : "1px solid grey", // Add a custom border color
                      borderRadius: "6px", // Optional: Add border radius for styling
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "grey", // Adjust border color for the outlined variant
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "grey", // Border color on hover
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "grey", // Border color when focused
                      },
                    }}
                  >
                    <MenuItem value="" disabled>
                      {t.main.payment}
                    </MenuItem>

                    <MenuItem value={"1"}>{t.main.refundable}</MenuItem>
                    <MenuItem value={"2"}>{t.main.nonRefundable}</MenuItem>
                  </Select>
                </FormControl>
              </MDBox>

              <MDBox mb={2}>
                <FormControl fullWidth>
                  <Select
                    labelId="product-label"
                    id="demo-simple-select"
                    value={selectedProduct}
                    onChange={handleChangeProduct}
                    fullWidth
                    className="select_div"
                    error={error && !selectedProduct}
                    inputProps={{
                      "aria-label": "Without label",
                    }}
                    displayEmpty
                    sx={{
                      border:
                        error && !selectedProduct
                          ? "1px solid red"
                          : "1px solid grey", // Add a custom border color
                      borderRadius: "6px", // Optional: Add border radius for styling
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "grey", // Adjust border color for the outlined variant
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "grey", // Border color on hover
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "grey", // Border color when focused
                      },
                    }}
                  >
                    <MenuItem value="" disabled>
                      {t.main.selectProduct}
                    </MenuItem>
                    {productData?.map((product) => (
                      <MenuItem key={product.id} value={product.id}>
                        {getLang === "ar"
                          ? product.product_name_ar
                          : getLang === "rs"
                          ? product.product_name_rs
                          : product.product_name_en}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </MDBox>
            </FormControl>
            <Box className="form_btn">
              <MDButton
                onClick={handleClose}
                variant="gradient"
                color="success"
                fullWidth
              >
                {t.main.cancel}
              </MDButton>
              <MDButton
                onClick={() => {
                  setError(true);
                  handleRequestStatus(selectedId);
                }}
                variant="gradient"
                color="success"
                fullWidth
              >
                {t.main.send}
              </MDButton>
            </Box>
          </form>
        </DialogContent>
      </Dialog>
      <Footer />
    </DashboardLayout>
  );
};

export default ManageQuotes;
